export * from './lib/interfaces/ICategory';
export * from './lib/interfaces/IColumn';
export * from './lib/interfaces/IOrder';
export * from './lib/interfaces/IPartner';
export * from './lib/interfaces/IPriority';
export * from './lib/interfaces/IService';
export * from './lib/interfaces/IStatus';
export * from './lib/interfaces/IDocument';
export * from './lib/interfaces/ITemplate';
export * from './lib/interfaces/IApiResponse';
export * from './lib/interfaces/IDoc';
export * from './lib/interfaces/IFolder';
export * from './lib/interfaces/ISMS';
export * from './lib/interfaces/IEmail';
export * from './lib/interfaces/IClip';
export * from './lib/interfaces/IComplaint';
export * from './lib/format';
export * from './lib/enums';
export * from './lib/dto';
export * from './lib/customer/enums';
export * from './lib/dimensions';
export * from './lib/interfaces/IDocument';
export * from './lib/finance';
export * from './lib/tags';
export * from './lib/planning';
export * from './lib/custom-fields';
export * from './lib/interfaces/IKnowledge';
export * from './lib/cost-center';
export * from './lib/label-calc';
export * from './lib/tech-spec';
export * from './lib/interfaces/product-attributes.interface';
export * from './lib/enums/product-attribute-type.enum';
export * from './lib/interfaces/ITask';
export * from './lib/tasks';
export * from './lib/interfaces/IMeetingSlot';
export var EVarScope;
(function (EVarScope) {
    EVarScope["PRIVATE"] = "private";
    EVarScope["PUBLIC"] = "public";
})(EVarScope || (EVarScope = {}));
export var EVarInput;
(function (EVarInput) {
    EVarInput["TEXT"] = "TEXT";
    EVarInput["TEXTAREA"] = "TEXTAREA";
    EVarInput["NUMERIC"] = "NUMERIC";
    EVarInput["SECRET"] = "SECRET";
    EVarInput["FILE"] = "FILE";
    EVarInput["COLOR"] = "COLOR";
    EVarInput["JSON"] = "JSON";
    EVarInput["SELECT"] = "SELECT";
})(EVarInput || (EVarInput = {}));
export var EACLItem;
(function (EACLItem) {
    EACLItem["ORDERS"] = "orders";
    EACLItem["INVOICES"] = "invoices";
    EACLItem["PAYMENTS"] = "payments";
    EACLItem["REPORTS"] = "reports";
    EACLItem["SETTINGS"] = "settings";
    EACLItem["USERS"] = "users";
    EACLItem["NOTIFICATIONS"] = "notifications";
    EACLItem["EMAIL"] = "email";
    EACLItem["SMS"] = "sms";
    EACLItem["DOCUMENTS"] = "documents";
    EACLItem["PRODUCTS"] = "products";
    EACLItem["PARTNERS"] = "partners";
    EACLItem["CRM"] = "crm";
    EACLItem["PROJECTS"] = "projects";
    EACLItem["TASKS"] = "tasks";
    EACLItem["CALENDAR"] = "calendar";
    EACLItem["NOTES"] = "notes";
    EACLItem["CHAT"] = "chat";
    EACLItem["APPROVALS"] = "approvals";
    EACLItem["WORKHOURS"] = "workhours";
    EACLItem["LABEL_CALC"] = "label_calc";
    EACLItem["COST_CENTER"] = "cost_center";
    EACLItem["STATUSES"] = "statuses";
    EACLItem["CUSTOM_FIELDS"] = "custom_fields";
    EACLItem["STATS"] = "stats";
    EACLItem["KNOWLEDGE"] = "knowledge";
    EACLItem["FORMS"] = "forms";
    EACLItem["SIGNING"] = "signing";
    EACLItem["MATERIALS"] = "materials";
    EACLItem["PRODUCT_GROUPS"] = "product_groups";
    EACLItem["TEMPLATES"] = "templates";
    EACLItem["POLLS"] = "polls";
    EACLItem["COMMENTS"] = "comments";
    EACLItem["MES"] = "mes";
    EACLItem["COMPLAINTS"] = "complaints";
})(EACLItem || (EACLItem = {}));
export var EPriceModel;
(function (EPriceModel) {
    EPriceModel["CALC"] = "calc";
    EPriceModel["SIMPLE"] = "simple";
    EPriceModel["CALC_SUM"] = "calc_sum";
    EPriceModel["COMPLEX"] = "complex";
    EPriceModel["STEP"] = "step";
    EPriceModel["ITEM"] = "item";
})(EPriceModel || (EPriceModel = {}));
export const PRICE_MAP = [
    { model: EPriceModel.CALC, label: 'Kalkulacija' },
    { model: EPriceModel.SIMPLE, label: 'Enostavna' },
    { model: EPriceModel.COMPLEX, label: 'Formula' },
    { model: EPriceModel.STEP, label: 'Stopnje' },
    { model: EPriceModel.ITEM, label: 'Izdelek' },
];
export var ERegistrationType;
(function (ERegistrationType) {
    ERegistrationType["START"] = "start";
    ERegistrationType["PAUSE"] = "pause";
    ERegistrationType["LUNCH"] = "lunch";
})(ERegistrationType || (ERegistrationType = {}));
export var EPriceParameterType;
(function (EPriceParameterType) {
    EPriceParameterType["NUM"] = "number";
})(EPriceParameterType || (EPriceParameterType = {}));
export var EApprovalState;
(function (EApprovalState) {
    EApprovalState["REVISE"] = "revise";
    EApprovalState["APPROVE"] = "approve";
})(EApprovalState || (EApprovalState = {}));
export * from './lib/messaging/ISystemMessage';
export var EChannelAuthType;
(function (EChannelAuthType) {
    EChannelAuthType["APIKEY"] = "apikey";
    EChannelAuthType["OAUTH2"] = "oauth2";
    EChannelAuthType["NONE"] = "none";
})(EChannelAuthType || (EChannelAuthType = {}));
export var EChannelStatus;
(function (EChannelStatus) {
    EChannelStatus["OK"] = "ok";
    EChannelStatus["ERROR"] = "error";
    EChannelStatus["UNAUTHORIZED"] = "unauthorized";
    EChannelStatus["INITIAL"] = "initial";
})(EChannelStatus || (EChannelStatus = {}));
export var EChannelApp;
(function (EChannelApp) {
    EChannelApp["OFFICE365"] = "office365";
    EChannelApp["GMAIL"] = "gmail";
    EChannelApp["MINIMAX"] = "minimax";
    EChannelApp["IMAP"] = "imap";
})(EChannelApp || (EChannelApp = {}));
export var EPollType;
(function (EPollType) {
    EPollType["ORDER"] = "order";
    EPollType["PARTNER"] = "partner";
})(EPollType || (EPollType = {}));
